/**
 * Created by Carsten Bühler
 * User: CBuehler on 16.12.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

import layerFactory from '../utils/LayerFactory';
import { findAndSortLayerDataSource, findLogicalLayerInSets } from '../utils/map-config-util';

export default class LeafletLayerManagerPlugin {

    constructor(props) {
        console.log('LeafletLayerManager constructor()', props);
        this.layers = {};
    }

    init(map, o) {
        console.log('LeafletLayerManager init()', { map, o });
        this.map = map;
        this.o = o;
        this.updateLayers(o);
    }

    initOptions(o) {
        return this.options(o);
    }

    options(o) {
        Object.keys(this.layers).forEach(layerKey => {
            //Todo shallowEquals options?
            const l = this.layers[ layerKey ];
            //if (l.controller && l.controller.update && !shallowEqual(l.controller.options, o)) {
            if (l.controller && l.controller.options) {
                l.controller.options(o);
            }
        });
    }

    remove() {
        console.log('LeafletLayerManager remove()');
        this._removeLayerByIds(Object.keys(this.layers));
    }

    update(map, o) {
        console.log('LeafletLayerManager update()', { map, o });
        this.o = o;
        this.map = map;

        this.updateLayers(o);

        Object.keys(this.layers).forEach(layerKey => {
            //Todo shallowEquals options?
            const l = this.layers[ layerKey ];
            //if (l.controller && l.controller.update && !shallowEqual(l.controller.options, o)) {
            if (l.controller && l.controller.update) {
                l.controller.update(map, o);
            }
        });

    }

    /**
     *
     * @param layerDescriptions
     * @param activeUuids - null means all active
     * @param baseLayerDescriptions
     * @param baseLayerId
     * @param defaultBaseLayerId
     */
    updateLayers({
        layerDescriptions = [],
        activeUuids = null,
        baseLayerDescriptions = [],
        baseLayerId,
        defaultBaseLayerId
    }) {
        let layerDataSources = findAndSortLayerDataSource(layerDescriptions, activeUuids);
        let baseLayers = [];
        layerDataSources = layerDataSources && layerDataSources.map(lds => {
            let copy = { ...lds };
            const logicalLayer = lds.logicalLayerId && findLogicalLayerInSets(layerDescriptions, lds.logicalLayerId);
            if (logicalLayer) {
                copy.zIndex = logicalLayer.zIndex;
            }
            return copy;
        });

        baseLayerId = baseLayerId || defaultBaseLayerId;
        if (baseLayerId) {
            const idx = baseLayerDescriptions.findIndex(logicLayer => logicLayer.id === baseLayerId);
            if (idx >= 0) {
                baseLayers = findAndSortLayerDataSource(baseLayerDescriptions[ idx ]);
            } else {
                console.warn('BaseLayer id: ' + baseLayerId + ' not found', baseLayerDescriptions);
            }
        }

        if (baseLayers.length === 0 && baseLayerDescriptions.length > 0) {
            baseLayers = findAndSortLayerDataSource(baseLayerDescriptions[ 0 ]);
        }

        layerDataSources = baseLayers.concat(layerDataSources);

        const toAdd = layerDataSources.filter(lds => !this.layers[ lds.id ]);

        const toRemove = Object.keys(layerDataSources.reduce((pv, cv) => {
            delete pv[ cv.id ];
            return pv;
        }, { ...this.layers }));

        if (toRemove.length + toAdd.length > 0) {
            console.info('Layer changed! remove: ', toRemove, 'add', toAdd);
            this._removeLayerByIds(toRemove);

            toAdd.forEach(lds => {
                try {
                    let config = lds.config;
                    config = (typeof config === 'string') ? JSON.parse(config) : { ...config };
                    const layer = layerFactory(this.map, this.o, lds, config, config.plugin, this.context);
                    layer && (this.layers[ lds.id ] = layer);
                } catch (e) {
                    console.error('Error Adding Layer ', lds, 'to map', e);
                }
            });
        }

    }

    _removeLayerByIds(layerIds) {
        layerIds.forEach(id => {
            const layer = this.layers[ id ];
            if (layer) {
                layer.clearLayers && layer.clearLayers();
                if (layer.controller && layer.controller.remove) {
                    layer.controller.remove(this.map);
                }
                this.map.removeLayer(layer.getInternalLayer && layer.getInternalLayer() || layer);
                layer.off && layer.off();
            } else {
                console.error('Try remove Layer ' + id + ' from layers', this.layers);
            }

            delete this.layers[ id ];

        });
    }

}

LeafletLayerManagerPlugin.staticPlugin = true;



// WEBPACK FOOTER //
// ./js/plugins/LeafletLayerManagerPlugin.js